
export default function AlaiawebRoute(){

    var url = window.location.toString();
    window.location = url.replace('/alaiaweb', '');
}